<template>
	<div class="icon-filter">
		<svg
			width="46.000000"
			height="46.000000"
			viewBox="0 0 46 46"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
		>
			<desc>Created with Pixso.</desc>
			<defs>
				<clipPath id="clip103_1172">
					<rect
						id="Fill=true"
						width="20.000000"
						height="20.000000"
						transform="translate(13.000000 13.000000)"
						fill="white"
						fill-opacity="0"
					/>
				</clipPath>
				<clipPath id="clip103_1175">
					<rect
						id="Icon_play_solid"
						width="20.000000"
						height="20.000000"
						transform="translate(96.000000 8.000000)"
						fill="white"
						fill-opacity="0"
					/>
				</clipPath>
			</defs>
			<rect
				id="button"
				rx="12.000000"
				width="46.000000"
				height="46.000000"
				fill="var(--theme-color)"
				fill-opacity="1.000000"
			/>
			<g clip-path="url(#clip103_1172)">
				<path
					id="path (Border)"
					d="M29.39 14.3C29.1 14.18 28.81 14.12 28.5 14.12L17.5 14.12C17.18 14.12 16.88 14.18 16.6 14.3C16.32 14.42 16.08 14.59 15.87 14.81C15.66 15.03 15.49 15.28 15.38 15.57C15.26 15.86 15.2 16.17 15.2 16.5L15.2 18.41C15.2 18.75 15.29 19.13 15.48 19.53C15.65 19.93 15.87 20.25 16.13 20.51L19.27 23.82C19.41 23.99 19.52 24.2 19.62 24.46C19.73 24.73 19.79 24.96 19.79 25.16L19.79 29.58C19.79 30.02 19.9 30.43 20.14 30.79C20.35 31.13 20.64 31.4 21 31.59C21.36 31.78 21.74 31.87 22.14 31.87C22.57 31.86 22.96 31.75 23.33 31.52L24.49 30.78C24.65 30.68 24.8 30.55 24.93 30.39C25.05 30.25 25.16 30.09 25.25 29.92C25.34 29.75 25.41 29.57 25.46 29.39C25.51 29.2 25.54 29.01 25.54 28.83L25.54 25.25C25.54 24.99 25.6 24.72 25.72 24.44C25.84 24.16 25.98 23.95 26.15 23.81L29.74 20.63C30.02 20.36 30.28 19.98 30.47 19.56C30.68 19.09 30.79 18.65 30.79 18.25L30.79 16.41C30.79 16.1 30.73 15.8 30.61 15.52C30.49 15.25 30.33 15 30.11 14.79C29.9 14.58 29.66 14.42 29.39 14.3Z"
					fill="#FFFFFF"
					fill-opacity="1.000000"
					fill-rule="evenodd"
				/>
			</g>
		</svg>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({})
export default class IconFilter extends Vue {}
</script>

<style scoped lang="scss">
.icon-filter {
	display: flex;
}
</style>
